
import Component from '../../../assets/scripts/modules/component'

const VISIBILITY_DELAY = 30 * 1000 // 30 sec

export default class WhatsappButtonComponent extends Component {
  init () {
    this.button = this.element.querySelector('.whatsapp-button__close')
    this.timeout = null

    if (!this.button) {
      return
    }

    this.focusableElements = [...this.element.querySelectorAll('a[href], button, input, select')]
    this.focusableElements.forEach(element => element.setAttribute('tabindex', -1))

    this.button.addEventListener('click', () => this.hideButton())

    if (sessionStorage.getItem('whatsapp-button') === 'true') {
      this.showButton()
    } else if (sessionStorage.getItem('whatsapp-button') === 'false') {
      this.hideButton()
    } else {
      window.clearTimeout(this.timeout)
      this.timeout = window.setTimeout(() => this.showButton(), VISIBILITY_DELAY)
    }
  }

  showButton () {
    this.focusableElements.forEach(element => element.removeAttribute('tabindex'))
    window.requestAnimationFrame(() => this.element.classList.add('whatsapp-button--visible'))
    sessionStorage.setItem('whatsapp-button', 'true')
  }

  hideButton () {
    this.focusableElements.forEach(element => element.setAttribute('tabindex', -1))
    window.requestAnimationFrame(() => this.element.classList.remove('whatsapp-button--visible'))
    sessionStorage.setItem('whatsapp-button', 'false')
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.whatsapp-button').forEach(element => {
  element.instance = element.instance || new WhatsappButtonComponent(element)
}))
